import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../../Style/SideMenu/style.css";
import contactme from "../../images/5138237.png";
import axios from "axios";

const SideMenu = ({ sideMenu, setSidemenu }) => {
  const navigate = useNavigate();
  const [headerMenu, setHeaderMenu] = useState([]);
  const [openDropdown, setOpenDropdown] = useState(null); // main dropdown
  const [openSubDropdown, setOpenSubDropdown] = useState(null); // nested dropdown

  const getSelectedHomeCategory = async () => {
    try {
      const res = await axios.get(`api/homecategory/get-home-category`);
      setHeaderMenu(res.data.data[0]?.headerMenu || []);
    } catch (err) {
      console.error("Error loading header menu", err);
    }
  };

  useEffect(() => {
    getSelectedHomeCategory();
  }, []);

  // Toggle dropdowns
  const toggleDropdown = (menuName) => {
    setOpenDropdown(openDropdown === menuName ? null : menuName);
  };
  const toggleSubDropdown = (submenuName) => {
    setOpenSubDropdown(openSubDropdown === submenuName ? null : submenuName);
  };

  return (
    <div
      className={`${
        sideMenu ? "sideMenu sideMenu__open" : "sideMenu"
      } sticky-top top-sticky`}
    >
      <ul>
        {/* 🟣 Destinations Dropdown */}
       <li className="submenu">
  {/* Main clickable link */}
  <Link
    to="/all-destinations"
    className="submenu-title"
    onClick={() => setSidemenu(false)}
  >
    DESTINATIONS
  </Link>

  {/* Dropdown toggle arrow */}
  <div
    className="submenu-toggle"
    onClick={() => toggleDropdown("destinations")}
  >
    {openDropdown === "destinations" ? "▲" : "▼"}
  </div>


          {openDropdown === "destinations" && (
            <ul className="submenu-list">
              {/* Domestic Dropdown */}
              <li className="submenu">
                <div
                  className="submenu-title small"
                  onClick={() => toggleSubDropdown("domestic")}
                >
                  Domestic
                  <span>{openSubDropdown === "domestic" ? "▲" : "▼"}</span>
                </div>
                {openSubDropdown === "domestic" && (
                  <ul className="submenu-list nested">
                     <li>
                      <Link onClick={() => setSidemenu(false)} to="/category/Andaman and Nicobar ">
                      Andaman and Nicobar                      
                       </Link>
                    </li>
                     <li>
                      <Link onClick={() => setSidemenu(false)} to="/category/Goa">
                        Goa
                      </Link>
                    </li> <li>
                      <Link onClick={() => setSidemenu(false)} to="/category/Himachal Pradesh">
                        Himachal Pradesh
                      </Link>
                    </li> <li>
                      <Link onClick={() => setSidemenu(false)} to="/category/Kargil">
                        Kargil
                      </Link>
                    </li> <li>
                      <Link onClick={() => setSidemenu(false)} to="/category/Karnataka">
                        Karnataka
                      </Link>
                    </li>
                     <li>
                      <Link onClick={() => setSidemenu(false)} to="/category/Kashmir">
                        Kashmir
                      </Link>
                    </li>
                    <li>
                      <Link onClick={() => setSidemenu(false)} to="/category/Kerala">
                        Kerala
                      </Link>
                    </li><li>
                      <Link onClick={() => setSidemenu(false)} to="/category/Lahaul">
                        Lahaul
                      </Link>
                    </li><li>
                      <Link onClick={() => setSidemenu(false)} to="/category/Lakshadweep">
                        Lakshadweep
                      </Link>
                    </li>
                    <li>
                      <Link onClick={() => setSidemenu(false)} to="/category/Leh Ladakh">
                        Leh Ladakh
                      </Link>
                    </li>
                    <li>
                      <Link onClick={() => setSidemenu(false)} to="/category/Meghalaya">
                        Meghalaya
                      </Link>
                    </li> <li>
                      <Link onClick={() => setSidemenu(false)} to="/category/Rajasthan">
                        Rajasthan
                      </Link>
                    </li> <li>
                      <Link onClick={() => setSidemenu(false)} to="/category/Sikkim">
                        Sikkim
                      </Link>
                    </li>
                    <li>
                      <Link onClick={() => setSidemenu(false)} to="/category/Spiti Valley">
                        Spiti Valley
                      </Link>
                    </li>
                    <li>
                      <Link onClick={() => setSidemenu(false)} to="/category/Uttarakhand">
                        Uttarakhand
                      </Link>
                    </li>
                  </ul>
                )}
              </li>

              {/* International Dropdown */}
              <li className="submenu">
                <div
                  className="submenu-title small"
                  onClick={() => toggleSubDropdown("international")}
                >
                  International
                  <span>{openSubDropdown === "international" ? "▲" : "▼"}</span>
                </div>
                {openSubDropdown === "international" && (
                  <ul className="submenu-list nested"> <li>
                      <Link onClick={() => setSidemenu(false)} to="/category/Azerbaijan">
                        Azerbaijan
                      </Link>
                    </li>
                    <li>
                      <Link onClick={() => setSidemenu(false)} to="/category/Bali">
                        Bali
                      </Link>
                    </li> <li>
                      <Link onClick={() => setSidemenu(false)} to="/category/Dubai">
                        Dubai
                      </Link>
                    </li>
                     <li>
                      <Link onClick={() => setSidemenu(false)} to="/category/Georgia">
                        Georgia
                      </Link>
                    </li> <li>
                      <Link onClick={() => setSidemenu(false)} to="/category/Ibiza">
                        Ibiza
                      </Link>
                    </li> <li>
                      <Link onClick={() => setSidemenu(false)} to="/category/Iceland">
                        Iceland
                      </Link>
                    </li> <li>
                      <Link onClick={() => setSidemenu(false)} to="/category/Istanbul">
                        Istanbul
                      </Link>
                    </li> <li>
                      <Link onClick={() => setSidemenu(false)} to="/category/Kazakhstan">
                        Kazakhstan
                      </Link>
                    </li><li>
                      <Link onClick={() => setSidemenu(false)} to="/category/Kenya">
                        Kenya
                      </Link>
                    </li><li>
                      <Link onClick={() => setSidemenu(false)} to="/category/Maldives">
                        Maldives
                      </Link>
                    </li><li>
                      <Link onClick={() => setSidemenu(false)} to="/category/Nepal">
                        Nepal
                      </Link>
                    </li><li>
                      <Link onClick={() => setSidemenu(false)} to="/category/Sri Lanka">
                        Sri Lanka
                      </Link>
                    </li><li>
                      <Link onClick={() => setSidemenu(false)} to="/category/Tanzania">
                        Tanzania
                      </Link>
                    </li>
                    <li>
                      <Link onClick={() => setSidemenu(false)} to="/category/Thailand">
                        Thailand
                      </Link>
                    </li>
                    
                    <li>
                      <Link onClick={() => setSidemenu(false)} to="/category/Vietnam">
                        Vietnam
                      </Link>
                    </li>
                    
                  </ul>
                )}
              </li>
              <li>
  <Link onClick={() => setSidemenu(false)} to="/customise-trip">
    Customize Your Trip
  </Link>
</li>

            </ul>
          )}
        </li>

        {/* 🟢 Travel Themes Dropdown */}
        <li className="submenu">
          <div className="submenu-title" onClick={() => toggleDropdown("themes")}>
            TRAVEL THEMES
            <span>{openDropdown === "themes" ? "▲" : "▼"}</span>
          </div>
          {openDropdown === "themes" && (
            <ul className="submenu-list">
              <li><Link onClick={() => setSidemenu(false)} to="/category/Adventure">Adventure</Link></li>
              <li><Link onClick={() => setSidemenu(false)} to="/category/ASG Special's">ASG Special's </Link></li>
              <li><Link onClick={() => setSidemenu(false)} to="/category/Autumn">Autumn</Link></li>
              <li><Link onClick={() => setSidemenu(false)} to="/category/Backpacking Trips">Backpacking Trips</Link></li>
              <li><Link onClick={() => setSidemenu(false)} to="/category/Bike Trips">Bike Trips</Link></li>
              <li><Link onClick={() => setSidemenu(false)} to="/category/Bachelors and Party">Bachelors and Party</Link></li>
              <li><Link onClick={() => setSidemenu(false)} to="/category/Beaches and Islands">Beaches and Islands</Link></li>
              <li><Link onClick={() => setSidemenu(false)} to="/category/Festival Diaries">Festival Diaries</Link></li>
              <li><Link onClick={() => setSidemenu(false)} to="/category/Igloo Stay">Igloo Stay</Link></li>
              <li><Link onClick={() => setSidemenu(false)} to="/category/NYE">NYE</Link></li>
              <li><Link onClick={() => setSidemenu(false)} to="/category/Road Trips">Road Trips</Link></li>
              <li><Link onClick={() => setSidemenu(false)} to="/category/Adventure">Romantic Getaways</Link></li>
              <li><Link onClick={() => setSidemenu(false)} to="/category/Adventure">Land Packages</Link></li>
              <li><Link onClick={() => setSidemenu(false)} to="/category/Adventure">Safari Specials</Link></li>
              <li><Link onClick={() => setSidemenu(false)} to="/category/Summer Trips">Summer Trips</Link></li>
              <li><Link onClick={() => setSidemenu(false)} to="/category/Winter Trips">Winter Trips</Link></li>
              <li><Link onClick={() => setSidemenu(false)} to="/category/Adventure">Wellness Escapes</Link></li>

            </ul>
          )}
        </li>

        {/* 🟡 Dynamic categories (optional) */}
        {headerMenu?.map((item) => (
          <li key={item}>
            <Link onClick={() => setSidemenu(false)} to={`/category/${item}`}>
              {item}
            </Link>
          </li>
        ))}

        {/* <li>
          <Link onClick={() => setSidemenu(false)} to="/about">
            About Us
          </Link>
        </li>
        <li>
          <Link onClick={() => setSidemenu(false)} to="/contact">
            Contact Us
          </Link>
        </li> */}

        <div className="text-center Mon_font">
          <img src={contactme} alt="contact" />
          <button
            onClick={() => navigate("/contact")}
            className="btn btn-warning"
          >
            Talk to our expert
          </button>
        </div>
      </ul>
    </div>
  );
};

export default SideMenu;
